/* v30 24.10.2026: «Benachrichtigen» für Schweiz/Europa → Base44 waitlist-join (Push an Ali, Bestätigungsmail). */
(function(){
  document.addEventListener('submit', function(e){
    var f = e.target; if (!f.matches || !f.matches('[data-m30-notify]')) return;
    e.preventDefault();
    var inp = f.querySelector('input[type=email]'), btn = f.querySelector('button'), ok = f.querySelector('.m30-notify__ok'), er = f.querySelector('.m30-notify__err');
    var mail = (inp.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) { inp.focus(); inp.setAttribute('aria-invalid','true'); return; }
    btn.disabled = true; er.hidden = true;
    var api = (window.MOUD && window.MOUD.api) || 'https://base44.app/api/apps/69c988953e5fbde3013c1ad9/functions/';
    fetch(api + 'waitlist-join', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: mail, product: f.dataset.product, country: f.dataset.cc, lang: f.dataset.lang === 'de' ? 'de' : (f.dataset.lang || 'en'), source: 'shop' }) })
      .then(function(r){ return r.json().catch(function(){ return { ok: r.ok }; }); })
      .then(function(j){
        if (j && j.ok) { f.querySelector('.m30-notify__row').hidden = true; ok.hidden = false; try { window.moudTrack && moudTrack('notify_signup', f.dataset.product); } catch(_){} }
        else { er.hidden = false; btn.disabled = false; }
      })
      .catch(function(){ er.hidden = false; btn.disabled = false; });
  });
})();
